import { openCanvasDB } from "../../../util/indexedDBUtils";

/**
 * Stores a marker in IndexedDB
 * @param {Object} params - Parameters object
 * @param {Object} params.markerData - Marker data to store
 * @param {string} params.pageId - Page ID for storing marker
 */
export const storeMarkerInIndexedDB = async ({ markerData, pageId }) => {
  try {
    const db = await openCanvasDB();
    if (!db.objectStoreNames.contains("canvasMarkers")) {
      return;
    }
    const transaction = db.transaction(["canvasMarkers"], "readwrite");
    const store = transaction.objectStore("canvasMarkers");

    // Ensure pageId is a valid key (string or number)
    let validPageId = pageId;
    if (
      typeof validPageId === "undefined" ||
      validPageId === null ||
      validPageId === ""
    ) {
      // fallback to a default string if pageId is not valid
      validPageId = "defaultCanvasPage";
    }

    store.put({ id: validPageId, data: markerData });
  } catch (e) {
    // Silently handle errors
  }
};
